import React, {useContext, useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Dialog, Item} from '@zebra-fed/zds-react-desktop';
import {SnackbarContent} from "../../styled-components/shared";
import ShowPassword from '../ShowPassword';
import firebaseUtil from '../../data/FirebaseUtil';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import FormHelperText from '@material-ui/core/FormHelperText';
import config from '../../data/application.properties'
import '@zebra-fed/icons/Alert/index.css';
import {useTranslation} from "react-i18next";
import {MessageResponseContext} from "../../data/MessageLocalizationProvider";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const CustomTextarea = styled.textarea`
    margin-top: 20px;
    border: none;
    border: 1px solid gray;
    border-radius: 5px;
    width: 90%;
    &:focus-visible {
        outline: none !important;
      }
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
  margin-top: 0;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledTextField = styled(TextField)`
  width: 220px;
  display: flex;
`;

const ElementWrapper = styled.div`
    display: flex;
    padding-top: 8px;
`

const RoleSelector = styled(FormControl)`
    width: 220px;
    padding-top: 8px;
`  

export default function AddNoteModal(props) {
    const { getAddedNote =()=>{}, clearNote, noteValue } = props;
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const { getKeyItem} = useContext(MessageResponseContext);
    const [singleUser, setSingleUser] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        role: "None",
      });
    const [checkErrors, setCheckErrors] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConf, setShowPasswordConf] = useState(false);
    const [addedNoteValue, setAddedNoteValue] = useState("")
    const errors = useRef([]);
    const serverMessage = useRef('');

    useEffect(()=>{
        clearNote &&  setAddedNoteValue("") ;
    }, [clearNote])

    useEffect(()=>{
        setAddedNoteValue(noteValue)
    },[noteValue])


    function handleTextareaChange(e) {
        setAddedNoteValue(e.target.value)
    }

    function handleCancel() {
        dialogRef.current.toggleDialog();
        // clearForm();
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }

    function handleAddClick() {
        dialogRef.current.toggleDialog();
        getAddedNote(addedNoteValue)
    }

    return (
        <>
            <Dialog 
                ref={dialogRef}
                key='dialog2'
                width='520px'            
                items={[
                   
                    <Item type='button' style={ButtonStyle} 
                    onClick={handleAddClick} 
                    disabled={isLoading}>Add</Item>,
                    <Item type='button' style={{...ButtonStyle, backgroundColor: '#757575', width: '102px'}} 
                    onClick={handleCancel} 
                    disabled={isLoading}>{t("cancel")}</Item>,
                ]}
                headerStyle={{display: 'none' }}
                bodyStyle={{padding: '0px', width: '100%'}}
                cardStyle={{ marginBottom: '80px'}}
                style={{cursor: isLoading ? 'wait' : 'default'}}>
                <ModalHeader>
                   {t('addNote')}
                </ModalHeader>
                <MainContent>
                    <CustomTextarea value={addedNoteValue} id="w3review" name="w3review" rows="5" cols="50" onChange={handleTextareaChange} />
                </MainContent>
                <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
                    <SnackbarContent error={true}>{serverMessage.current}</SnackbarContent>
                </Snackbar>
            </Dialog>
        </>
    )
}